<template>
  <BuyerOneColumnPage
    :title="title"
    subTitle="Suas avaliações sob aprovação pendentes de aprovação do anunciante"
    :icon="icon"
    :section="section"
    :description="description"
    :getContent="getBidPending"
    labelCard="Sua avaliação"
    buyerScope="UnfulilledPurchases"
    priceDescriptionPage="Sua avaliação"
    noVehicleLabel="Você não tem nenhuma avaliação sob aprovação pendente"
  />
</template>

<script>
import { BUYER_SECTION_PENDING } from "@/views/buyer/constants/BuyerSections";

import PlatformsMixins from "@/mixins/PlatformsMixins";
import BuyerComponentPagesMixins from "@/mixins/BuyerComponentPagesMixins";
import NavigateMixings from "@/mixins/NavigateMixings";

import BuyerOneColumnPage from "../BuyerOneColumnPage";
import { getBidPending } from "@/services/api/BuyerServiceApi";

export default {
  name: "BidPendingPage",
  mixins: [PlatformsMixins, BuyerComponentPagesMixins, NavigateMixings],
  components: { BuyerOneColumnPage },
  data: function () {
    return {
      ...BUYER_SECTION_PENDING,
      title: "Avaliação sob aprovação pendente",
      section: "Pendentes",
    };
  },
  methods: {
    getBidPending,
  },
};
</script>

<style lang="scss" scoped></style>
